import React from "react";

const AddMessage = ({
  register,
  errors,
  uploadedFile,
  watch,
  templateData,
}) => {
  const subjectCharacterLimit = 100;
  const messageCharacterLimit = 10000;

  const subject = watch("emailSubject") || "";
  const message = watch("emailMessage") || "";

  return (
    <div className=" r">
      <div className="mb-4">
        <label
          htmlFor="emailSubject"
          className="block text-gray-700 text-sm font-bold mb-2"
        >
          Email Subject:
        </label>
        <input
          type="text"
          readOnly
          onFocus={(e) => e.target.removeAttribute("readOnly")}
          id="emailSubject"
          placeholder="Enter email subject"
          {...register("emailSubject", {
            maxLength: {
              value: subjectCharacterLimit,
              message: `Subject cannot exceed ${subjectCharacterLimit} characters`,
            },
            defaultValue: uploadedFile
              ? `Complete with Docusign: ${uploadedFile.name}`
              : "",
          })}
          className="shadow appearance-none border ring-1 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-[#cfc9ff]"
        />
        {errors.emailSubject && (
          <p className="text-red-500 text-xs italic">
            {errors.emailSubject.message}
          </p>
        )}
        <p className="text-gray-500 text-xs mt-1">
          Characters remaining: {subjectCharacterLimit - subject?.length}
        </p>
      </div>
      <div>
        <label
          htmlFor="emailMessage"
          className="block text-gray-700 text-sm font-bold mb-2"
        >
          Email Message:
        </label>
        <textarea
          id="emailMessage"
          placeholder="Enter email message"
          {...register("emailMessage", {
            maxLength: {
              value: messageCharacterLimit,
              message: `Message cannot exceed ${messageCharacterLimit} characters`,
            },
          })}
          className="shadow appearance-none border rounded w-full ring-1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-32 resize-none focus:ring-2 focus:ring-[#cfc9ff]"
        />
        {errors.emailMessage && (
          <p className="text-red-500 text-xs italic">
            {errors.emailMessage.message}
          </p>
        )}
        <p className="text-gray-500 text-xs mt-1">
          Characters remaining: {messageCharacterLimit - message.length}
        </p>
      </div>
      <div className="mt-4">
        <label
          htmlFor="webhookUrl"
          className="block text-gray-700 text-sm font-bold mb-2"
        >
          Webhook URL:
        </label>

        <input
          type="text"
          id="webhookUrl"
          placeholder="Webhook URL"
          className="shadow appearance-none border rounded w-full ring-1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline resize-none focus:ring-2 focus:ring-[#cfc9ff]"
          {...register("webhookUrl", {
            pattern: {
              value:
                /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
              message: "Please enter a valid URL",
            },
          })}
        />
        {errors.webhookUrl && (
          <p className="text-red-500 text-xs italic">
            {errors.webhookUrl.message}
          </p>
        )}
      </div>
    </div>
  );
};

export default AddMessage;
